import Link from 'next/link';
import {useRouter} from 'next/router';
import React from 'react';

import {
    AggregatorRuleTag,
    BrowsePageContent,
    CertificationAggregatorApi,
    CertificationAggregatorCarousel,
    PaginatedContent,
} from '@udemy/browse-aggregator';

import {udemyApi} from 'src/lib/ud-global-fetch';

import {CARD_CAROUSEL_PAGE_SIZE} from '../../certification-preparation.react-component';

export const IssuerCertificationAggregatorCarouselWrapper = (props: {
    initialData: PaginatedContent<BrowsePageContent>;
}) => {
    const certificationAggregatorApi = new CertificationAggregatorApi(udemyApi);
    const router = useRouter();

    const title = gettext('Top Certification Issuers');
    const description = gettext(
        'Get Certified for top Industry Issuers through our catalog of certification preparation courses',
    );

    return (
        <CertificationAggregatorCarousel
            key={`${router.asPath}-issuer-aggregator-carousel`}
            title={title}
            subtitle={description}
            aggregatorType={[AggregatorRuleTag.ISSUER]}
            certificationAggregatorApi={certificationAggregatorApi}
            autoFetchOnMount={false}
            useStackedCards={false}
            initialData={props.initialData}
            pageSize={CARD_CAROUSEL_PAGE_SIZE}
            aggregatorCardProps={{
                linkComponent: (props: {href: string; children?: React.ReactNode}) => (
                    <Link {...props} legacyBehavior={false}>
                        {props.children}
                    </Link>
                ),
            }}
        />
    );
};

export const SubjectCertificationAggregatorCarouselWrapper = (props: {
    initialData: PaginatedContent<BrowsePageContent>;
}) => {
    const certificationAggregatorApi = new CertificationAggregatorApi(udemyApi);
    const router = useRouter();

    const title = gettext('Top Certification Subjects');
    const description = gettext(
        'Get Certified for in-demand skills through our catalog of certification preparation courses',
    );

    return (
        <CertificationAggregatorCarousel
            key={`${router.asPath}-subject-aggregator-carousel`}
            title={title}
            subtitle={description}
            aggregatorType={[AggregatorRuleTag.SUBJECT]}
            certificationAggregatorApi={certificationAggregatorApi}
            autoFetchOnMount={false}
            useStackedCards={false}
            initialData={props.initialData}
            pageSize={CARD_CAROUSEL_PAGE_SIZE}
            aggregatorCardProps={{
                linkComponent: (props: {href: string; children?: React.ReactNode}) => (
                    <Link {...props} legacyBehavior={false}>
                        {props.children}
                    </Link>
                ),
            }}
        />
    );
};
